import {
  Box,
  Card,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Edit as EditIcon,
  Eye as EyeIcon,
  Code as CodeIcon,
  Trash as TrashIcon,
} from 'react-feather';
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink } from 'react-router-dom';
import EmptyList from 'src/components/EmptyList';

const useStyles = makeStyles((theme) => ({
  root: {},
  table_list: {
    '& th': {
      padding: '5px',
    },
    '& td': {
      padding: '5px',
      color: theme.palette.tertiary.main,
      '& a,button': {
        padding: '0px 5px',
      },
    },
  },
}));

const Results = ({
  className,
  codes,
  page,
  setPage,
  resetPage,
  pageSize,
  setPageSize,
  sort,
  setSort,
  isLoading,
  deleteCode,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('codes');
  const { t: tCommon } = useTranslation('common');

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleSortChange = (order) => {
    resetPage();

    if (sort === order) {
      setSort(`-${order}`);
    } else {
      setSort(order);
    }
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table className={classes.table_list}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel
                    active={sort === 'company.name' || sort === '-company.name'}
                    direction={sort === 'company.name' ? 'asc' : 'desc'}
                    onClick={() => {
                      handleSortChange('company.name');
                    }}
                  >
                    {t('fields.company')}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={sort === 'code' || sort === '-code'}
                    direction={sort === 'code' ? 'asc' : 'desc'}
                    onClick={() => {
                      handleSortChange('code');
                    }}
                  >
                    {t('fields.code')}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={sort === 'type' || sort === '-type'}
                    direction={sort === 'type' ? 'asc' : 'desc'}
                    onClick={() => {
                      handleSortChange('type');
                    }}
                  >
                    {t('fields.type')}
                  </TableSortLabel>
                </TableCell>
                <TableCell align="right">{tCommon('tables.rows.actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {codes?.map((code) => (
                <TableRow hover key={code.id}>
                  <TableCell>{code.company.name}</TableCell>
                  <TableCell>{code.code}</TableCell>
                  <TableCell>{code.type}</TableCell>
                  <TableCell align="right">
                    <IconButton
                      color="primary"
                      value={code.id}
                      component={RouterLink}
                      to={`/app/codes/${code.id}/edit`}
                      disabled={isLoading}
                    >
                      <EditIcon></EditIcon>
                    </IconButton>
                    <IconButton
                      color="primary"
                      value={code.id}
                      component={RouterLink}
                      to={`/app/codes/${code.id}`}
                    >
                      <EyeIcon />
                    </IconButton>
                    <IconButton
                      color="primary"
                      onClick={() => deleteCode(code.id)}
                      disabled={isLoading}
                    >
                      <TrashIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {!isLoading && !codes?.length && (
            <EmptyList text={t('labels.empty_list_text')}>
              <CodeIcon />
            </EmptyList>
          )}
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={codes?.count || 0}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePageSizeChange}
        page={codes?.count ? page - 1 : 0}
        rowsPerPage={pageSize}
        rowsPerPageOptions={[25, 50, 100]}
      />
    </Card>
  );
};

Results.propTypes = {
  codes: PropTypes.array,
  page: PropTypes.number,
  setPage: PropTypes.func,
  resetPage: PropTypes.func,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func,
  sort: PropTypes.string,
  setSort: PropTypes.func,
  isLoading: PropTypes.bool,
  deleteCode: PropTypes.func,
};

export default Results;
